import { render, staticRenderFns } from "./SettingButtons.vue?vue&type=template&id=48ad4a6c&scoped=true&"
import script from "./SettingButtons.vue?vue&type=script&lang=js&"
export * from "./SettingButtons.vue?vue&type=script&lang=js&"
import style0 from "./SettingButtons.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SettingButtons.vue?vue&type=style&index=1&id=48ad4a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ad4a6c",
  null
  
)

export default component.exports